import styled, { css } from "styled-components";
import { getBrandStorage } from "../../utils/getBrand";
import { getCampaignColors } from "../../utils/getCampaignColors";
import { isDiferentiatedBrands } from "../../themes/themes";

import Typography from "@mui/material/Typography";

const brand = getBrandStorage();
const campaignColors = getCampaignColors();

export const Wrapper = styled.div`
	${({ theme }) => css`
		margin-bottom: 50px;
		margin-top: 50px;
	`}
`;

export const ButtonTrip = styled.button`
	${({ theme }) => css`
		border-radius: 10px;
		border-color: transparent;
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
		color: #ffffff;
		background-color: ${isDiferentiatedBrands(brand)
			? theme.palette.secondary.white
			: campaignColors.headerColor
			? campaignColors.headerColor
			: theme.palette.primary.main};
		width: 154px;
		height: 45px;
		font-size: 15px;
		font-weight: 600;
		text-transform: none;
		cursor: pointer;
	`}
`;

export const TitleTrip = styled(Typography)`
	${({ theme }) => css`
		font-size: 35px !important;
		font-weight: 700 !important;
		color: ${isDiferentiatedBrands(brand)
			? theme.palette.secondary.black
			: campaignColors.headerColor
			? campaignColors.headerColor
			: theme.palette.primary.main};
	`}
`;

export const LinkMailTrip = styled.a`
	${({ theme }) => css`
		color: ${isDiferentiatedBrands(brand)
			? theme.palette.secondary.black
			: campaignColors.headerColor
			? campaignColors.headerColor
			: theme.palette.primary.main};
	`}
	font-size: 16px;
	font-weight: 400;
`;

export const Arrow = styled.div`
	position: absolute;
	top: 85%;
	left: 45%;
	width: 159px;
	height: 59px;
	filter: drop-shadow(0 0.2rem 0.25rem rgba(0, 0, 0, 0.2));
	.spinner {
		background: #fff;
		border-radius: 50%;
		display: block;
		margin: 5% auto;
		position: relative;
		width: 59px;
		height: 59px;
	}
	@-webkit-keyframes pulse {
		0% {
			opacity: 0;
			background-position: center top;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
		10% {
			opacity: 0;
		}
		50% {
			opacity: 1;
			-moz-background-size: 20% auto;
			-o-background-size: 20% auto;
			-webkit-background-size: 20% auto;
			background-size: 20% auto;
		}
		90% {
			opacity: 0;
		}
		100% {
			opacity: 0;
			background-position: center bottom;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
	}
	@-moz-keyframes pulse {
		0% {
			opacity: 0;
			background-position: center top;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
		10% {
			opacity: 0;
		}
		50% {
			opacity: 1;
			-moz-background-size: 20% auto;
			-o-background-size: 20% auto;
			-webkit-background-size: 20% auto;
			background-size: 20% auto;
		}
		90% {
			opacity: 0;
		}
		100% {
			opacity: 0;
			background-position: center bottom;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
	}
	@-ms-keyframes pulse {
		0% {
			opacity: 0;
			background-position: center top;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
		10% {
			opacity: 0;
		}
		50% {
			opacity: 1;
			-moz-background-size: 20% auto;
			-o-background-size: 20% auto;
			-webkit-background-size: 20% auto;
			background-size: 20% auto;
		}
		90% {
			opacity: 0;
		}
		100% {
			opacity: 0;
			background-position: center bottom;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
	}
	@keyframes pulse {
		0% {
			opacity: 0;
			background-position: center top;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
		10% {
			opacity: 0;
		}
		50% {
			opacity: 1;
			-moz-background-size: 20% auto;
			-o-background-size: 20% auto;
			-webkit-background-size: 20% auto;
			background-size: 20% auto;
		}
		90% {
			opacity: 0;
		}
		100% {
			opacity: 0;
			background-position: center bottom;
			-moz-background-size: 0 auto;
			-o-background-size: 0 auto;
			-webkit-background-size: 0 auto;
			background-size: 0 auto;
		}
	}
	.scroll-down a {
		display: block;
		opacity: 0;
		-moz-transition: all 0.4s ease;
		-o-transition: all 0.4s ease;
		-webkit-transition: all 0.4s ease;
		transition: all 0.4s ease;
		line-height: 0;
		font-size: 0;
		color: transparent;
		margin-left: auto;
		margin-right: auto;
		-moz-background-size: 0 auto;
		-o-background-size: 0 auto;
		-webkit-background-size: 0 auto;
		background-size: 0 auto;
		-webkit-animation: pulse 1.5s 0s infinite normal ease forwards;
		-moz-animation: pulse 1.5s 0s infinite normal ease forwards;
		-o-animation: pulse 1.5s 0s infinite normal ease forwards;
		animation: pulse 1.5s 0s infinite normal ease forwards;
		background-image: url(images/arrow-down.svg);
		background-repeat: no-repeat;
	}
	.scroll-down a:before,
	.scroll-down a:after {
		content: ' ';
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		width: 100%;
		height: 100%;
		background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMzBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMzAgMjAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMwIDIwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxwYXRoIGZpbGw9IiMwMTM0NmIiIGQ9Ik0yMS44NSw3LjE2YzAsMC4zMDktMC4xMTgsMC42MTctMC4zNTMsMC44NTNsLTUuNjgxLDUuNjhjLTAuNDcxLDAuNDcxLTEuMjMzLDAuNDcxLTEuNzA0LDBsLTUuNjgxLTUuNjgNCgkJYy0wLjQ3LTAuNDcxLTAuNDctMS4yMzMsMC0xLjcwNGMwLjQ3MS0wLjQ3LDEuMjM0LTAuNDcsMS43MDQsMGw0LjgyOCw0LjgyOGw0LjgyOC00LjgyOGMwLjQ3Mi0wLjQ3LDEuMjM0LTAuNDcsMS43MDQsMA0KCQlDMjEuNzMxLDYuNTQzLDIxLjg1LDYuODUyLDIxLjg1LDcuMTZ6Ii8+DQo8L2c+DQo8L3N2Zz4NCg==)
			no-repeat center top;
		-moz-background-size: 100% auto;
		-o-background-size: 100% auto;
		-webkit-background-size: 100% auto;
		background-size: 100% auto;
	}
	.scroll-down a:before {
		-webkit-animation: pulse 1.5s 0.25s infinite normal ease forwards;
		-moz-animation: pulse 1.5s 0.25s infinite normal ease forwards;
		-o-animation: pulse 1.5s 0.25s infinite normal ease forwards;
		animation: pulse 1.5s 0.25s infinite normal ease forwards;
	}
	.scroll-down a:after {
		-webkit-animation: pulse 1.5s 0.5s infinite normal ease forwards;
		-moz-animation: pulse 1.5s 0.5s infinite normal ease forwards;
		-o-animation: pulse 1.5s 0.5s infinite normal ease forwards;
		animation: pulse 1.5s 0.5s infinite normal ease forwards;
	}
`;